module.exports = __webpack_public_path__ + "static/media/get_started_bg.460a6f61.png";